import React from 'react';
import { Link } from 'react-router-dom';

// data
import { catalogList } from 'data/data_catalog';

const DataCatalog = () => {
  const typeCount = catalogList.reduce((acc, item) => {
    acc[item.type] = (acc[item.type] || 0) + 1;
    return acc;
  }, {});
  return (
    <>
      <article className="l-auth__article c-article">
        <h5 className="c-article__subtitle">資料下載</h5>
        <p className="c-article__paragraph">
          本頁列出 LTSER
          彰化站長期觀測資料集，資料採分級管理方式提供，請登入會員並詳閱{' '}
          <Link to="/member-terms" className="e-link">
            會員約定條款
          </Link>{' '}
          及{' '}
          <Link to="/privacy-policy" className="e-link">
            隱私權政策
          </Link>{' '}
          說明，使用及下載資料請依規範使用。
        </p>
        <h5 className="c-article__subtitle">資料引用規範</h5>
        <p className="c-article__paragraph">
          使用本站資料時，除資料集有建議使用指定引用格式外，可參考以下格式標示來源：
        </p>
        <h5 className="c-article__subtitle text-indent-2">
          致謝引用方式可參考以下範例
        </h5>
        <p className="c-article__paragraph text-indent-4">
          資料使用致謝引用方式「感謝臺灣長期社會生態核心觀測站—彰化站提供之資料」
        </p>
        <h5 className="c-article__subtitle c-article__subtitle__last text-indent-2">
          資料使用參考引用方式
        </h5>
        <p className="text-block-indent-4">
          一、中文引用請註明
          「國科會臺灣長期社會生態核心觀測站—彰化站」，出處為：國科會臺灣長期社會生態核心觀測站—彰化站，網址
          https://ltsertwchanghua.org/
        </p>
        <p className="text-block-indent-4">
          二、英文引用請註明 Long-Term Social-Ecological Research (LTSER) -
          Changhua，出處為：Long-Term Social-Ecological Research (LTSER) -
          Changhua, https://ltsertwchanghua.org/
        </p>

        <div className="data-catalog-table-area">
          <div className="ovhbox">
            <table
              border={0}
              cellSpacing={0}
              cellPadding={0}
              className="table-style1"
            >
              <tbody>
                <tr>
                  <td>類別</td>
                  <td>資料名稱</td>
                </tr>
                {catalogList.map((item, index) => (
                  <tr key={`${item.type}-${item.name}-${index}`}>
                    {index === 0 ||
                    catalogList[index - 1].type !== item.type ? (
                      <td
                        rowSpan={typeCount[item.type]}
                        style={{
                          verticalAlign: 'top',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {item.type}
                      </td>
                    ) : null}
                    <td>
                      <div>
                        <Link
                          to={item.link}
                          className="e-link"
                          target={item.newTab ? '_blank' : undefined}
                          rel={item.newTab ? 'noopener noreferrer' : undefined}
                        >
                          {item.name}
                        </Link>
                        <p>{item.description}</p>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </article>
    </>
  );
};

export default DataCatalog;
